import React from "react";
import { Route } from "react-router-dom";

import { ClientList } from "./resources/clients";
import Whiteboard from "./components/whiteboard";
import ProcessRental from "./components/processRental";
import ProcessRentalEdit from "./components/processRentalEdit";
import ProcessTour from "./components/processTour";
import ProcessTourEdit from "./components/processTourEdit";
import TourProcessingEnhanced from "./components/tour/TourProcessingEnhanced";
import ToursWhiteboard from "./components/toursWhiteboard";
import RentalAgenda from "./components/rentalAgenda";
import RentalsWhiteboard from "./components/rentalsWhiteboard";
import RentalDetails from "./components/rentalDetails";
import VehicleHistory from "./components/history";
import ItemHistory from "./components/itemHistory";
import CurrentFleet from "./components/fleet";
import MotoSchedule from "./components/motoSchedule";
import MotoScheduleStart from "./components/motoScheduleStart";
import GpsSchedule from "./components/gpsSchedule";
import GpscheduleStart from "./components/gpsScheduleStart";
import VansSchedule from "./components/vansSchedule";
import VansScheduleStart from "./components/vansScheduleStart";
import FleetAllocation from './components/fleetAllocation';
import VehicleSwithActivity from "./components/vehicleSwithActivity";
import ReportDetails from "./components/reportDetails";
import ReportsMetrics from "./components/reportsMetrics";
import reportYearSales from "./components/reportYearSales";
import reportEmail from "./components/reportEmail";
import reportToursCount from "./components/reportToursCount";
import reportRentalsAvg from "./components/reportRentalsAvg";
import reportSales from "./components/reportSales";
import reportRentalsAvgByRange from "./components/reportRentalsAvgByRange";
import reportToursCharges from "./components/reportToursCharges"
import mergeAccounts from "./components/mergeAccounts";
import reportToursChargeDetails from "./components/reportToursChargeDetails";
import reportFutureIncome from "./components/reportFutureIncome";
import TourManagementView from "./features/tours/views/TourManagementView";

export default [
  <Route
    exact
    path="/customer"
    render={routeProps => <ClientList resource="clients" {...routeProps} />}
  />,
  // <Route exact path="/vehicles" render={(routeProps) => <VehicleList resource="vehicles" {...routeProps} />} />,
  // <Route exact path="/transfers" render={(routeProps) => <TransfersList resource="transfers" {...routeProps} />} />,
  <Route exact path="/transfers" component={Whiteboard} />,
  <Route exact path="/tours" component={ToursWhiteboard} />,
  <Route exact path="/process_rental/:id" component={ProcessRental} />,
  <Route exact path="/process_rental_edit/:id" component={ProcessRentalEdit} />,
  <Route exact path="/process_tour/:id" component={ProcessTour} />,
 /*  <Route exact path="/process_tour_edit/:id" component={ProcessTourEdit} />, */
  <Route exact path="/process_tour_enhanced/:id" component={TourProcessingEnhanced} />,
  <Route exact path="/weekly_rentals" component={RentalAgenda} />,
  <Route exact path="/whiteboard" component={RentalsWhiteboard} />,
  <Route exact path="/history/:id" component={VehicleHistory} />,
  <Route exact path="/rental_details/:id" component={RentalDetails} />,
  <Route exact path="/rental_due/:id" component={RentalDetails} />,
  <Route exact path="/current_fleet" component={CurrentFleet} />,
  <Route exact path="/item_history/:type/:id" component={ItemHistory} />,
  <Route exact path="/moto_schedule" component={MotoSchedule} />,
  <Route exact path="/moto_schedule/start" component={MotoScheduleStart} />,

  <Route exact path="/vans_schedule" component={VansSchedule} />,
  <Route exact path="/vans_schedule/start" component={VansScheduleStart} />,

  <Route exact path="/gps_schedule" component={GpsSchedule} />,
  <Route exact path="/gps_schedule/start" component={GpscheduleStart} />,
  <Route exact path="/fleet_allocation" component={FleetAllocation} />,
  <Route exact path="/vehicle_switch_activity/:id" component={VehicleSwithActivity} />,
  <Route exact path="/reports" component={ReportDetails} />,
  <Route exact path="/reports_metrics" component={ReportsMetrics} />,
  <Route exact path="/reportsYearSales" component={reportYearSales} />,
  <Route exact path="/reportsEmails" component={reportEmail} />,
  <Route exact path="/reportsTours" component={reportToursCount} />,
  <Route exact path="/reportsRentals" component={reportRentalsAvg} />,
  <Route exact path="/reportsRentalsByRange" component={reportRentalsAvgByRange} />,
  <Route exact path="/reportsSales" component={reportSales} />,
  <Route exact path="/reportFutureIncome" component={reportFutureIncome} />,
  <Route exact path="/reportToursCharges" component={reportToursCharges} />,
  <Route exact path="/reportToursCharges/:id" component={reportToursChargeDetails} />,
  <Route exact path="/mergeAccounts/:id" component={mergeAccounts} />,
  <Route exact path="/tour-management" component={TourManagementView} />
];



// WEBPACK FOOTER //
// ./src/routes.js